import React, { useState, useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import copy from "../../assets/copy.png";
import colon from "../../assets/colon.png";
import "./tools.css";
import alarm from "../../assets/alarm1.png";
import paint from "../../assets/paint.png";
import { BiPlus, BiReset } from "react-icons/bi";
import "bootstrap-icons/font/bootstrap-icons.css";
import pencil from "../../assets/pencil.png";
import bin from "../../assets/bin.png";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FaEllipsisV } from "react-icons/fa";

// Checklist Items --------------------->LocalStorage  Name Trimster--1;;;;;
function Trimster5({ selectedTool, setSelectedTool }) {
  const popupRef = useRef(null);

  const handleTogglePopup = (index) => {
    setChecklistItems((prevItems) =>
      prevItems.map((item, i) => ({
        ...item,
        showPopup: i === index ? !item.showPopup : false,
      }))
    );
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setChecklistItems((prevItems) =>
        prevItems.map((item) => ({ ...item, showPopup: false }))
      );
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const defaultChecklist = [
    {
      content: "Blood Test",
      showPopup: false,
    },
    {
      content:
        "STI (sexually transmitted infection) tests: gonorrhea, chlamydia, syphilis, HIV Infectious STI (sexually transmitted infection) tests: gonorrhea, chlamydia, syphilis, HIV Infectious disease (sexually transmitted infection) tests: gonorrhea, chlamydia, syphilis, HIV Infectious disease  tests: Hepatitis B, Hepatitis C, VZV (chicken pox), Rubella, TB (skin or blood test)",
      showPopup: false,
    },
  ];

  const loadChecklist = () => {
    const savedChecklist = JSON.parse(localStorage.getItem("checklistItems4"));
    return savedChecklist || defaultChecklist;
  };

  const [checklistItems, setChecklistItems] = useState(loadChecklist);
  const [newChecklistContent, setNewChecklistContent] = useState("");
  const [isAddNewVisible, setIsAddNewVisible] = useState(false);
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [colorPopupIndex, setColorPopupIndex] = useState(null);
  const [copiedText, setCopiedText] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editContent, setEditContent] = useState("");
  const [copiedIndex, setCopiedIndex] = useState(null);

  const [reminders, setReminders] = useState(
    JSON.parse(localStorage.getItem("reminders")) || {}
  );

  useEffect(() => {
    localStorage.setItem("checklistItems4", JSON.stringify(checklistItems));
  }, [checklistItems]);

  const loadCheckedItems = () => {
    return JSON.parse(localStorage.getItem("checkedItems3")) || [];
  };

  const [checkedItems, setCheckedItems] = useState(loadCheckedItems);

  useEffect(() => {
    localStorage.setItem("checklistItems4", JSON.stringify(checklistItems));
    localStorage.setItem("checkedItems4", JSON.stringify(checkedItems));
  }, [checklistItems, checkedItems]);

  const handleCheckboxChange = (index) => {
    setCheckedItems((prev) => {
      const updatedChecked = prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index];

      localStorage.setItem("checkedItems4", JSON.stringify(updatedChecked));
      return updatedChecked;
    });
  };

  const handleAddNewChecklist = () => {
    if (newChecklistContent.trim() !== "") {
      setChecklistItems([
        ...checklistItems,
        { content: newChecklistContent, showPopup: false },
      ]);
      setNewChecklistContent("");
      setIsAddNewVisible(false);
    }
  };

  const newCheckieRef = useRef(null);

  const handleShowAddNewBox = () => {
    if (newCheckieRef.current) {
      newCheckieRef.current.scrollIntoView({ behavior: "smooth" });
    }
    setIsAddNewVisible(true);
  };

  const handleResetChecklist = () => {
    setChecklistItems(defaultChecklist);
    setShowResetPopup(false);
  };

  const handleShowResetPopup = () => {
    setShowResetPopup(true);
  };

  const handleCancelReset = () => {
    setShowResetPopup(false);
  };

  // For Color...............................
  const handleShowColorPopup = (index) => {
    setColorPopupIndex(index);
    handleTogglePopup();
  };

  const handleSetColor = (color) => {
    if (colorPopupIndex !== null) {
      const updatedChecklistItems = checklistItems.map((item, index) =>
        index === colorPopupIndex ? { ...item, bgColor: color } : item
      );
      setChecklistItems(updatedChecklistItems);
      setColorPopupIndex(null);
    }
  };

  const handleDeleteChecklist = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedChecklistItems = checklistItems.filter(
          (_, i) => i !== index
        );
        setChecklistItems(updatedChecklistItems);
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      }
    });
  };

  const confirmDelete = (index) => {
    const updatedChecklistItems = checklistItems.filter((_, i) => i !== index);
    setChecklistItems(updatedChecklistItems);
    toast.dismiss();
  };

  const handleEditChecklist = (index) => {
    setEditIndex(index);
    setEditContent(checklistItems[index].content);
  };

  const handleCopyToClipboard = (text, index) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedIndex(index);
        setTimeout(() => setCopiedIndex(null), 1000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const handleSaveEdit = () => {
    if (editContent.trim() === "") {
      toast.error("Checklist content cannot be empty!", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    const updatedChecklistItems = checklistItems.map((item, index) =>
      index === editIndex ? { ...item, content: editContent } : item
    );

    setChecklistItems(updatedChecklistItems);
    setEditIndex(null);
    setEditContent("");

    toast.success("Checklist updated successfully!", {
      position: "top-center",
      autoClose: 1500,
      className: "toast-center-enter",
    });
  };

  const availableColors = [
    "#EFE2FF",
    "#DDDCFF",
    "#C5DCFF",
    "#B9FFDD",
    "#DFEFA0",
    "#FFE9BD",
    "#FFE2E2",
    "#F8F8F8",
    "#B383EE",
    "#41AE8D",
    "#98C1FF",
    "#FBCAFF",
    "#CFD4FF",
    "#BBF9E6",
    "#C9FFAF",
    "#FFFCAA",
    "#FFDB9C",
    "#FFE4E9",
    "#FF8659",
    "#C79235",
  ];

  const handleSetReminder = (index) => {
    Swal.fire({
      title: "Set Reminder",
      input: "datetime-local",
      inputLabel: "Choose Date & Time",
      showCancelButton: true,
      confirmButtonText: "Set Reminder",
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        const selectedTime = new Date(result.value).getTime();
        const updatedReminders = { ...reminders, [index]: selectedTime };

        setReminders(updatedReminders);
        localStorage.setItem("reminders", JSON.stringify(updatedReminders));

        // Schedule the reminder
        scheduleReminder(index, selectedTime);
      }
    });
  };
  const scheduleReminder = (index, time) => {
    const now = new Date().getTime();
    const delay = time - now;

    if (delay > 0) {
      setTimeout(() => {
        toast.info(`Reminder: ${checklistItems[index].content}`, {
          position: "top-center",
          autoClose: 5000,
        });

        // Remove reminder after notification
        const updatedReminders = { ...reminders };
        delete updatedReminders[index];
        setReminders(updatedReminders);
        localStorage.setItem("reminders", JSON.stringify(updatedReminders));
      }, delay);
    }
  };
  useEffect(() => {
    Object.entries(reminders).forEach(([index, time]) => {
      scheduleReminder(parseInt(index), time);
    });
  }, []);

  return (
    <>
      <div
        className="trim"
        style={{
          backgroundColor: "#B24C76",
          overflowX: "hidden",
        }}
      >
        <div className="trim-white">
          <div className="bread-container">
            <nav aria-label="breadcrumb">
              <ol className="crumb">
                <li className="breadcrumblist">
                  <Link
                    to="/"
                    className="breadcrumb-link"
                    onClick={() => setSelectedTool("")}
                  >
                    Home
                  </Link>
                </li>
                <li className="breadcrumblist">
                  <Link to="/checklist" className="breadcrumb-link">
                    Trimester
                  </Link>
                </li>
                <li className="breadcrumblist active">After Delivery</li>
              </ol>
            </nav>
          </div>
          <h1
            id="head-for-all"
            style={{
              color: "#B24C76",
              textAlign: "center",
              textTransform: "initial",
            }}
          >
            After Delivery Checklist
          </h1>
          <div className="addholder">
            <div className=" addnew">
              <a>
                <button
                  style={{
                    width: "120px",
                    border: "none",
                    fontSize: "20px",
                    background: "transparent",
                    marginRight: "0px",
                  }}
                  onClick={handleShowAddNewBox}
                >
                  <BiPlus style={{ marginTop: "-5px" }} size={25} />
                  Add New
                </button>
              </a>
              <a>
                <button
                  style={{
                    width: "120px",
                    border: "none",
                    fontSize: "20px",
                    background: "transparent",
                  }}
                  onClick={handleShowResetPopup}
                >
                  <BiReset style={{ marginTop: "-5px" }} size={25} />
                  Reset
                </button>
              </a>
            </div>
          </div>

          {checklistItems.length == 0 ? (
            <p
              style={{
                textAlign: "center",
                fontWeight: "bold",
                marginTop: "30px",
                color: "red",
              }}
            >
              No data here
            </p>
          ) : (
            checklistItems.map((item, index) => (
              <div
                key={index}
                style={{ backgroundColor: item.bgColor }}
                className="checklist"
              >
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id={`checklist${index}`}
                  onChange={() => handleCheckboxChange(index)}
                  checked={checkedItems.includes(index)}
                />
                <p
                  className={`trim-check-p ${
                    checkedItems.includes(index) ? "strikethrough" : ""
                  }`}
                >
                  {item.content}
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "40px",
                  }}
                  id="btns-checklist-act"
                >
                  <div className="action-buttons">
                    <div className="tooltip-container">
                      <img
                        src={bin}
                        alt="Trash"
                        onClick={() => handleDeleteChecklist(index)}
                        id="dlt-icon-trim"
                      />
                      <span className="tooltip-text">Delete</span>
                    </div>

                    <div className="tooltip-container">
                      <img
                        src={pencil}
                        alt="Edit"
                        onClick={() => handleEditChecklist(index)}
                      />
                      <span className="tooltip-text">Edit </span>
                    </div>
                  </div>

                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    {/* Tooltip for copied text */}
                    {copiedIndex === index && (
                      <div className="copy-tooltip">Copied!</div>
                    )}

                    {/* Copy Button */}

                    <div className="tooltip-container">
                      <img
                        src={copy}
                        alt="Copy"
                        onClick={() =>
                          handleCopyToClipboard(item.content, index)
                        }
                        className="copy-icon"
                      />
                    </div>
                  </div>

                  <FaEllipsisV
                    className="three-dots-icon"
                    onClick={() => handleTogglePopup(index)}
                  />
                </div>

                {item.showPopup && (
                  <div className="popups" ref={popupRef}>
                    <div className="popups-content">
                      <div
                        className=" paint"
                        onClick={() => handleShowColorPopup(index)}
                      >
                        <img
                          src={paint}
                          alt="set_background"
                          // style={{ margin: "0px 20px 0px 20px" }}
                        />
                        <h5 style={{ cursor: "pointer" }}>BG Color</h5>
                      </div>
                      <div
                        className="alrms"
                        onClick={() => handleSetReminder(index)}
                      >
                        <img src={alarm} alt="set_background" />
                        <h5 style={{ cursor: "pointer" }}>Set Reminder</h5>
                      </div>
                    </div>
                  </div>
                )}

                {editIndex === index && (
                  <div className="overlay">
                    <div className="edit-box">
                      <textarea
                        value={editContent}
                        onChange={(e) => setEditContent(e.target.value)}
                      />
                      <div>
                        <button onClick={handleSaveEdit} id="edit-box-btn1">
                          Save
                        </button>
                        <button
                          onClick={() => setEditIndex(null)}
                          id="edit-box-btn2"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}

          {isAddNewVisible && (
            <div className="new-checklist" id="newcheckie">
              <textarea
                placeholder="Enter your new checklist ...(Ex.Dr's prescribe.)"
                value={newChecklistContent}
                onChange={(e) => setNewChecklistContent(e.target.value)}
              />
              <div className="btn-add-new" ref={newCheckieRef}>
                <button onClick={handleAddNewChecklist} id="add-check">
                  Add Checklist
                </button>
                <button onClick={() => setIsAddNewVisible(!isAddNewVisible)}>
                  {isAddNewVisible ? "Cancel" : "Add New Checklist"}
                </button>
              </div>
            </div>
          )}

          {showResetPopup && (
            <div className="reset-popup">
              <div className="reset-popup-content">
                <h4>Are you sure you want to reset the checklist?</h4>
                <div className="reset-btn">
                  <button onClick={handleResetChecklist}>Yes</button>
                  <button onClick={handleCancelReset}>No</button>
                </div>
              </div>
            </div>
          )}

          {colorPopupIndex !== null && (
            <div className="color-popup">
              <div className="color-popup-content">
                <h4 style={{ textAlign: "center", marginBottom: "30px" }}>
                  Select a Background Color
                </h4>
                <div className="color-options">
                  {availableColors.map((color, idx) => (
                    <div
                      key={idx}
                      onClick={() => handleSetColor(color)}
                      style={{
                        backgroundColor: color,
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        margin: "10px",
                        cursor: "pointer",
                      }}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <ToastContainer position="top-center" autoClose={2000} /> */}
      <ToastContainer />
    </>
  );
}

export default Trimster5;
